var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"siwa"}},[_c('div',{attrs:{"id":"appleid-signin","data-type":"sign-in","data-color":"black","data-border":"false","data-border-radius":"6","data-width":"200","data-height":"36"}})])
}]

export { render, staticRenderFns }